import { useProcessAnalysisStore } from '../../store/process-analysis-store/process-analysis-store';
import { MainSection as MainSectionAgents } from './agents-tab/main-section/main-section';
import { MainSection as MainSectionBoards } from './boards-tab/main-section/main-section';
import { MainSection as MainSectionPortfolios } from './portfolios-tab/main-section/main-section';
import { Tab } from './process-analysis.type';
import { MainSection as MainSectionTeams } from './teams-tab/main-section/main-section';

export const ProcessAnalysisMainSection = () => {
  const activeTab = useProcessAnalysisStore((state) => state.activeTab);

  switch (activeTab) {
    case Tab.Portfolios:
      return <MainSectionPortfolios />;
    case Tab.Teams:
      return <MainSectionTeams />;
    case Tab.Boards:
      return <MainSectionBoards />;
    case Tab.Agents:
      return <MainSectionAgents />;
    default:
      return null;
  }
};
